import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Router-aware anchor scrolling. The nav points at `/#menu`, `/#about` and
 * `/#gallery`, so a click from another route has to navigate first and only
 * then scroll — the browser's native anchor handling never fires for those.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    // Defer a tick so the target route has actually rendered. A timeout rather
    // than requestAnimationFrame: rAF never fires in a background tab, which
    // would leave the page unscrolled when the visitor switches to it.
    const id = window.setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);

    return () => window.clearTimeout(id);
  }, [pathname, hash]);

  return null;
}
